<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:transparent;display:block;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
<defs>
  <filter id="ldio-1guy7dhz3j2-filter" x="-100%" y="-100%" width="300%" height="300%" color-interpolation-filters="sRGB">
    <feGaussianBlur in="SourceGraphic" stdDeviation="2.4000000000000004"/>
    <feComponentTransfer result="cutoff">
      <feFuncA type="table" tableValues="0 0 0 0 0 0 1 1 1 1 1"/>
    </feComponentTransfer>
  </filter>
</defs>
<g filter="url(#ldio-1guy7dhz3j2-filter)"><g transform="translate(50 50)">
<g transform="rotate(170.644)">
  <circle cx="17" cy="0" r="8.33866" fill="#c2ccff">
    <animate attributeName="r" keyTimes="0;0.5;1" values="3.5999999999999996;8.399999999999999;3.5999999999999996" dur="7.142857142857142s" repeatCount="indefinite" begin="-0.14s"/>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="7.142857142857142s" repeatCount="indefinite" begin="0s"/>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(344.11)">
  <circle cx="17" cy="0" r="3.79794" fill="#aeb8ff">
    <animate attributeName="r" keyTimes="0;0.5;1" values="3.5999999999999996;8.399999999999999;3.5999999999999996" dur="3.571428571428571s" repeatCount="indefinite" begin="-0.11200000000000002s"/>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="3.571428571428571s" repeatCount="indefinite" begin="-0.028000000000000004s"/>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(160.398)">
  <circle cx="17" cy="0" r="7.99019" fill="#9aa4ff">
    <animate attributeName="r" keyTimes="0;0.5;1" values="3.5999999999999996;8.399999999999999;3.5999999999999996" dur="2.380952380952381s" repeatCount="indefinite" begin="-0.084s"/>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="2.380952380952381s" repeatCount="indefinite" begin="-0.05600000000000001s"/>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(339.509)">
  <circle cx="17" cy="0" r="4.29694" fill="#8690ff">
    <animate attributeName="r" keyTimes="0;0.5;1" values="3.5999999999999996;8.399999999999999;3.5999999999999996" dur="1.7857142857142856s" repeatCount="indefinite" begin="-0.05600000000000001s"/>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="1.7857142857142856s" repeatCount="indefinite" begin="-0.084s"/>
</g>
</g><g transform="translate(50 50)">
<g transform="rotate(161.443)">
  <circle cx="17" cy="0" r="7.34067" fill="#727cf5">
    <animate attributeName="r" keyTimes="0;0.5;1" values="3.5999999999999996;8.399999999999999;3.5999999999999996" dur="1.4285714285714284s" repeatCount="indefinite" begin="-0.028000000000000004s"/>
  </circle>
  <animateTransform attributeName="transform" type="rotate" keyTimes="0;1" values="0;360" dur="1.4285714285714284s" repeatCount="indefinite" begin="-0.11200000000000002s"/>
</g>
</g></g>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>